module.exports = "https://sf6-scmcdn2-tos.pstatp.com/motor/pc/_next/static/images/menu-bottom@3x-9b2e7376a011f32d756da3d1fc09773b.png";